import { motion } from "framer-motion";
import PropTypes from "prop-types";

/**
 * AnimatedDiv - Base animated div component with common animation props
 * 
 * A flexible wrapper around framer-motion's motion.div that accepts
 * variants and common animation props. Use this for custom animations
 * that don't fit the pre-built atomic components.
 * 
 * @component
 * @example
 * ```jsx
 * import { AnimatedDiv } from "../ui/Motion";
 * import { FADE_IN_VARIANTS } from "../../constants/animations";
 * 
 * <AnimatedDiv 
 *   variants={FADE_IN_VARIANTS}
 *   initial="hidden"
 *   animate="visible"
 *   className="my-content"
 * >
 *   Content here
 * </AnimatedDiv>
 * ```
 */
export const AnimatedDiv = ({
    children,
    variants,
    initial = "hidden",
    animate = "visible",
    exit,
    transition,
    className,
    style,
    ...props
}) => (
    <motion.div
        variants={variants}
        initial={initial}
        animate={animate}
        exit={exit}
        transition={transition}
        className={className}
        style={style}
        {...props}
    >
        {children}
    </motion.div>
);

AnimatedDiv.propTypes = {
    children: PropTypes.node,
    variants: PropTypes.object,
    initial: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.bool]),
    animate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    exit: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    transition: PropTypes.object,
    className: PropTypes.string,
    style: PropTypes.object
};

export default AnimatedDiv;
